import { USER } from './UserActions';
import { Reducer, combineReducers } from 'redux'
import { IUser } from '../../store/interface'
// const userDefault:IUser = {
//     name:'',
//     logged: false,
//     verified: false,
//     id:'',
//     personId:'',
//     membershipCode:'',
//     membershipCategory:'',
//     fullName:'',
//     NIRC:'',
//     PersonalContactNumber:'',
//     PersonalEmailAddress:'',
//     PersonalAddress:'',
//     CompanyName:'',
//     Position:'',
//     CompanyContactNumber:'',
//     CompanyAddress:'',
//     SalaryRange:'',
//     ProfessionalCategory:[],
//     RegulationBody:'',
//     InstitutionAssociationBodyNumber:''

// }

const userDefault: IUser = {
    id: '',
    table: '', // "User"
    emailAdd: '',
    userStatus: '',
    userStatusDetails: '',
    personId: '',
    gender: '',
    fullName: '',
    icNo: '',
    icFileName: '',
    contactNo: '',
    permanentAdd: '',
    mailingAdd: '',
    compName: '',
    compReg: '',
    compPosition: '',
    compContactNo: '',
    compAdd: '',
    compSalaryRange: '',
    country: '',
    professionList: [],
    createdDT: '',
    createdBy: '',
    lastEdited: '',
    lastEditedBy: '',
    lastLogin : '',
    userRoles : [],
    logged: false,
    verified: false,
    version : 1,
    searchKeywords : '',
    faceImageList: [],
    faceImageLastUpdated: '',
    updateState :0 ,
    cart: undefined
}


// const UserReducer:Reducer<IUser> = (state = userDefault, action) => {
//     var user = Object.assign({}, state);
//     switch (action.type) {
//         case USER.login.success:
//         case USER.verify.success:
//         case USER.Profile.success:
//             return {
//                 ...state , id:action.payload.id, name:action.payload.name, 
//                 personId:action.payload.personId,
//                 verified:true, logged:true,
//                 membershipCode:action.payload.membershipCode,
//                 membershipCategory:action.payload.membershipCategory,
//                 FullName:action.payload.FullName,
//                 NIRC:action.payload.NIRC,
//                 PersonalContactNumber:action.payload.PersonalContactNumber,
//                 PersonalEmailAddress:action.payload.PersonalEmailAddress,
//                 PersonalAddress:action.payload.PersonalAddress,
//                 CompanyName:action.payload.CompanyName,
//                 Position:action.payload.Position,
//                 CompanyContactNumber:action.payload.CompanyContactNumber,
//                 CompanyAddress:action.payload.CompanyAddress,
//                 SalaryRange:action.payload.SalaryRange,
//                 ProfessionalCategory: (action.payload.ProfessionalCategory === undefined ? [] :  action.payload.ProfessionalCategory),
//                 RegulationBody:action.payload.RegulationBody,
//                 InstitutionAssociationBodyNumber:action.payload.InstitutionAssociationBodyNumber
//             }
//         case USER.logout.success:
//             user.logged = false;
//             return user;
//         case USER.verify.error:
//             user.verified = true;
//             return user;
//         default:
//             return user;
//     }
// }

const  UserReducer: Reducer<IUser> = (state = userDefault, action) => {
    var user = Object.assign({}, state);
    switch (action.type) {
        case USER.Profile.update:
            return { ...state, processing: true, processState: 0 };
        case USER.login.success:
        case USER.verify.success:
        case USER.Profile.success:
            let r = {...user, ...action.payload.doc};
            r.verified = true;
            r.logged = true;
            r.ProfessionalCategory = [];
            r.processing = false;
            r.processState = 1;
            return r;
        case USER.Profile.error:
            //let e = {...user, "error": action.payload.error}
            let e = {...user, ...action.payload}
            e.logged = true;
            return e;
        case USER.logout.success:
            user.logged = false;
            return user;
        case USER.verify.error:
            user.verified = true;
            return user;
        
        // case USER.Discount.success:
        //     let d = {...action.payload.doc};
        //     return d;
        // case USER.Discount.error:
        

        default:
            return user;
    }
}

export default UserReducer